import type { ListAllRegionsResponse, Provider } from '@repo/api-gw-sdk';
import { useDAL } from '@/contexts/useDAL';
export const useSupportedRegions = (): Partial<Record<Provider, string[]>> => {
  const dal = useDAL();
  const {
    data: regions
  }: {
    data: ListAllRegionsResponse | undefined;
  } = dal.inventory.regions.useListAll();
  return regions?.regions ?? {};
};